import React from "react";
import { getPhone, getOpeningHours } from "../helpers/ContentStateHelper";

export default {
  SuccessMessage: {
    Any:
      "Your plan has been added successfully. You can select the plan you wish to view using the button below, or via the Account menu.",
    HOL:
      "Your policy has been added successfully. You can select the policy you wish to view using the button below, or via the Account menu."
  },

  SuccessSummaryLiveIndividual: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          Your method for managing the added plan has automatically been set to
          ‘Online’. This means that we’ll email you whenever there's something
          new for you to view online. You’ll only be able to access your plan
          documents by logging in.
        </p>
        <p>
          If you'd prefer to receive your documents by post, you can amend your
          preference in your profile. You can also request paper copies of your
          documents by calling us on <strong>{getPhone(props)}</strong>,{" "}
          {getOpeningHours(props)}.
        </p>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          Your method for managing the added policy has automatically been set
          to ‘Online’. This means that we’ll email you whenever there's
          something new for you to view online. You’ll only be able to access
          your policy documents by logging in.
        </p>
        <p>
          If you'd prefer to receive your documents by post, you can amend your
          preference in your profile. You can also request paper copies of your
          documents by calling us on <strong>01202 544032</strong>,{" "}
          {getOpeningHours(props)}.
        </p>
      </React.Fragment>
    )
  },
  SuccessSummarySmeLCorpDep: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          Your method for receiving your claims information for the added plan
          has automatically been set to ‘Online’. This means that we’ll email
          you whenever there is something new for you to view online. You’ll
          only be able to access your claims documents by logging in.
        </p>

        <p>
          If you'd prefer to receive your claims documents by post, you can
          amend your preference in your profile. You can also request paper
          copies of your documents by calling us on{" "}
          <strong>{getPhone(props)}</strong>, {getOpeningHours(props)}.
        </p>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
          Your method for receiving your claims information for the added policy
          has automatically been set to ‘Online’. This means that we’ll email
          you whenever there is something new for you to view online. With our
          online service you’ll only be able to access your claims documents by
          logging in.
        </p>

        <p>
          If you would prefer to receive your claims documents by post you can
          amend your preference for managing your policy in the ‘My profile’
          section of the online service.
        </p>
      </React.Fragment>
    )
  },
  ButtonViewOtherPlans: {
    Any: "View my other plans",
    HOL: "View my other policies"
  }
};
